export const SAVED_SEARCH_FREQUENCY_IMMEDIATELY = "IMMEDIATELY";
export const SAVED_SEARCH_FREQUENCY_HOURLY = "HOURLY";
export const SAVED_SEARCH_FREQUENCY_DAILY = "DAILY";
export const SAVED_SEARCH_FREQUENCY_WEEKLY = "WEEKLY";

export const SAVED_SEARCH_FREQUENCY_OPTIONS = [
  {
    display: "Immediately",
    adverb: SAVED_SEARCH_FREQUENCY_IMMEDIATELY,
  },
  {
    display: "Hourly",
    adverb: SAVED_SEARCH_FREQUENCY_HOURLY,
  },
  {
    display: "Daily",
    adverb: SAVED_SEARCH_FREQUENCY_DAILY,
  },
  {
    display: "Weekly",
    adverb: SAVED_SEARCH_FREQUENCY_WEEKLY,
  },
];

export const SAVED_SEARCH_EXPIRATION_OPTIONS = [
  { id: 1, name: "1 week", value: 1, type: "weeks" },
  { id: 2, name: "2 weeks", value: 2, type: "weeks" },
  { id: 3, name: "3 weeks", value: 3, type: "weeks" },
  { id: 4, name: "Never", value: "never", type: null },
];

export const SEARCH_PLACES_RADIUS = 10;
export const SEARCH_PLACES_RADIUS_MAX = 25;
export const SEARCH_PLACES_MAX_ALLOWED = 50;
export const SEARCH_AOIID_MAX_ALLOWED = 50;

export const SAVED_SEARCH_BOUND_TYPE_MAP_EXTENT = "mapextent";
export const SAVED_SEARCH_BOUND_TYPE_WORLD_WIDE = "worldwide";
export const SAVED_SEARCH_BOUND_TYPE_PLACES = "places";
export const SAVED_SEARCH_BOUND_TYPE_GEOGRAPHY = "geography";
export const SAVED_SEARCH_BOUND_TYPE_COUNTRIES = "countries";
export const SAVED_SEARCH_BOUND_TYPE_CITIES = "cities";
export const SAVED_SEARCH_BOUND_TYPE_CUSTOM = "custom";
export const SAVED_SEARCH_BOUND_TYPES = [
  SAVED_SEARCH_BOUND_TYPE_MAP_EXTENT,
  SAVED_SEARCH_BOUND_TYPE_WORLD_WIDE,
  SAVED_SEARCH_BOUND_TYPE_COUNTRIES,
  SAVED_SEARCH_BOUND_TYPE_CITIES,
  SAVED_SEARCH_BOUND_TYPE_CUSTOM,
  SAVED_SEARCH_BOUND_TYPE_PLACES,
  SAVED_SEARCH_BOUND_TYPE_GEOGRAPHY,
];

export const NOTIFICATION_BUILDER_COUNTRIES_LAYER_ID = "layer-country";
export const NOTIFICATION_BUILDER_COUNTRIES_LAYER_FIELD_ID = "_id";
export const NOTIFICATION_BUILDER_CITIES_LAYER_ID = "layer-city";
export const NOTIFICATION_BUILDER_CITIES_LAYER_FIELD_ID = "_id";
